import { render, staticRenderFns } from "./CardCoodevedores.vue?vue&type=template&id=4514b620&scoped=true"
import script from "./CardCoodevedores.vue?vue&type=script&lang=js"
export * from "./CardCoodevedores.vue?vue&type=script&lang=js"
import style0 from "./CardCoodevedores.vue?vue&type=style&index=0&id=4514b620&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4514b620",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4514b620')) {
      api.createRecord('4514b620', component.options)
    } else {
      api.reload('4514b620', component.options)
    }
    module.hot.accept("./CardCoodevedores.vue?vue&type=template&id=4514b620&scoped=true", function () {
      api.rerender('4514b620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CardCoodevedores.vue"
export default component.exports